module.exports = "<span class=\"font12 text-danger\" *ngIf=\"errorMessage !== null\">({{errorMessage}})</span>"